import React, { useCallback, useEffect, useState } from 'react';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import SearchDate from './SearchDate';
import SearchPeriod from './SearchPeriod';

import { SearchBarConatiner } from './ReportSearchBar.css.js';

const ReportSearchBar = ({ exportExcel, searchMap, setSearchMap }) => {
  const [dateValid, setDateValid] = useState(true);
  const cancellationToken = useCancellationToken();
  const updateSearchMap = useCallback((key, value) => {
    if (cancellationToken.isCancelled) {
      return
    }

    setSearchMap(searchMap => {
      return {
        ...searchMap,
        [key]: value
      }
    })
  }, [searchMap, cancellationToken])

  useEffect(() => () => cancellationToken.cancel(), []);

  return (
    <SearchBarConatiner>
      <div className="form-row">
        <SearchPeriod updateSearchMap={updateSearchMap} setDateValid={setDateValid} />
      </div>
      <div className="form-row">
        <SearchDate title='시작날짜' dateValid={dateValid} updateSearchMap={updateSearchMap} name='beginDate' />
        <SearchDate title='종료날짜' dateValid={dateValid} updateSearchMap={updateSearchMap} name='endDate' />
        <button className="btn btn-primary" onClick={() => exportExcel()}>출력</button>
      </div>
    </SearchBarConatiner>
  )
}

export default React.memo(ReportSearchBar);